import Multiplechoice from './Multiplechoice.jsx';
import Feedback from './Feedback.jsx';
import FreeResponse from './FreeResponse.jsx';
import RsvpToEvent from './RSVP.jsx';
import ChangeEmail from './ChangeEmail.jsx';
import InviteSpouse from './InviteSpouse.jsx';

import {
  MULTIPLE_CHOICE,
  FEEDBACK,
  FREE_RESPONSE,
  RSVP,
  CHANGE_EMAIL,
  INVITE_SPOUSE,
} from '../../../utils/constants';

const SurveyItem = ({ option }) => {
  switch (option) {
    case MULTIPLE_CHOICE:
      return <Multiplechoice option={option} />;
    case FEEDBACK:
      return <Feedback />;
    case FREE_RESPONSE:
      return <FreeResponse />;
    case RSVP:
      return <RsvpToEvent />;
    case CHANGE_EMAIL:
      return <ChangeEmail option={option} />;
    case INVITE_SPOUSE:
      return <InviteSpouse />;
  }
};

export default SurveyItem;
